import React from "react";

export default function NumberField({
  id,
  label,
  value,
  onChange,
  unit,
  step="1",
  min="0",
  max="10000000",
  pattern="[0-9]+(\.[0-9]+)?",
  placeholder="0",
  title,
  autoComplete="off",
  errors,
  locked=false
}:{
  id?: string;
  label: string;
  value: string | number;
  onChange?: (arg: React.ChangeEvent<HTMLInputElement>) => any;
  unit?: string;
  step?: string;
  min?: string;
  max?: string;
  pattern?: string;
  placeholder?: string;
  title?: string;
  autoComplete?: 'on' | 'off';
  errors?: string;
  locked?: boolean;
}){
  const fieldId = React.useId();
  const inputId = id ? `${id}${fieldId}` : fieldId;

  return(
    <div className="flex flex-col gap-2 w-full">
      <label
        htmlFor={inputId}
        className="flex gap-1 items-center font-bold text-[0.9375rem] leading-[120%] tracking-[-0.01rem]"
      >
        { locked && 
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M6.4 4.00005V5.60005H9.6V4.00005C9.6 3.11755 8.8825 2.40005 8 2.40005C7.1175 2.40005 6.4 3.11755 6.4 4.00005ZM4.8 5.60005V4.00005C4.8 2.23255 6.2325 0.800049 8 0.800049C9.7675 0.800049 11.2 2.23255 11.2 4.00005V5.60005C12.0825 5.60005 12.8 6.31755 12.8 7.20005V12.8C12.8 13.6825 12.0825 14.4 11.2 14.4H4.8C3.9175 14.4 3.2 13.6825 3.2 12.8V7.20005C3.2 6.31755 3.9175 5.60005 4.8 5.60005Z" fill="#8A95A8"/>
        </svg>
        }
        {label}
      </label>
      <div className={`flex items-center w-full h-15 relative border border-[#b0bcd1] box-border ${locked ? '' : 'bg-white'}`}>
        <input
          id={inputId}
          type="number" 
          value={value} 
          onChange={onChange} 
          className="w-full py-5 px-4 text-[1rem] leading-none tracking-[-0.01rem] text-[#101114]"
          min={min}
          max={max}
          pattern={pattern}
          placeholder={placeholder}
          title={title}
          step={step}
          aria-label={label}
          autoComplete={autoComplete}
          readOnly={locked}
        />
        { unit &&
          <span className="px-4 leading-none text-[1rem] text-right tracking-[-0.01rem] text-[#101114]">{unit}</span>
        }
      </div>
      {errors && (
        <div role="alert" aria-live="polite">
          {errors}
        </div>
      )}
    </div>
  )
}